export default {
    "ANNOTATED": "Annotated",
}